import styled from '@emotion/styled'
import { Menu } from '@material-ui/core'

interface ActionsMenuProps {
  $width?: number
  $opensUpward: boolean
}

const ActionsMenu = styled(Menu, {
  shouldForwardProp: (prop) => prop !== '$width' && prop !== '$opensUpward',
})<ActionsMenuProps>(({ theme, $width, $opensUpward }) => ({
  '& .MuiMenu-paper': {
    width: $width,
    marginTop: $opensUpward ? -theme.spacing(1) : theme.spacing(1),
    borderRadius: theme.palette.border.borderRadius,
    borderColor: theme.palette.border.light,
  },
}))

export { ActionsMenu }
